import { Accordion, AccordionItem, IconHandler } from '../../utils';

import { CandidaturasCardList } from '../candidatura';
import { CargosListType } from '../../types';
import { FaUserTie } from 'react-icons/fa';
import { FunctionComponent } from 'react';
import { useTranslation } from 'react-i18next';

const CargosList: FunctionComponent<CargosListType> = ({ cargos }) => {
  const { t } = useTranslation();
  return (
    <Accordion id={'accordionCargosCandidaturas'}>
      {cargos?.map((cargo) => (
        <AccordionItem
          key={cargo.id}
          header={
            <div className="d-flex w-100 justify-content-between">
              <div>{cargo.nome}</div>
              <div className="me-1">{`${cargo?.candidaturas?.length} ${t(
                `label.candidatura${cargo?.candidaturas?.length! !== 1 ? 's' : ''}`,
              )}`}</div>
            </div>
          }
        >
          {cargo.candidaturas?.length! > 0 ? (
            <CandidaturasCardList candidaturas={cargo.candidaturas!} />
          ) : (
            <div className="empty-body-card text-center p-2">
              <IconHandler Icon={FaUserTie}></IconHandler>
              <span className="text-muted">{t('texto.nenhuma_candidatura_cadastrada')}</span>
            </div>
          )}
        </AccordionItem>
      ))}
    </Accordion>
  );
};

export default CargosList;
